import { render, staticRenderFns } from "./AudienceInformNote.vue?vue&type=template&id=39f6f965&scoped=true"
import script from "./AudienceInformNote.vue?vue&type=script&lang=ts"
export * from "./AudienceInformNote.vue?vue&type=script&lang=ts"
import style0 from "./AudienceInformNote.vue?vue&type=style&index=0&id=39f6f965&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f6f965",
  null
  
)

export default component.exports